import { FC } from 'react';

import { ProfileDropdown } from './ProfileDropdown';
import { ButtonSquare, Icon } from '../../../shared/ui';
import { IconMap } from '../../../shared/sprite';
import { SelectTeamDropdown } from './SelectTeamDropdown';
import { useTeamPermissions } from '../../../features/teams';

import { WorkspaceSearch } from './WorkspaceSearch';

type Props = {
  onToggleMenu: () => void;
  onContactSupport: () => void;
};

export const Header: FC<Props> = ({ onToggleMenu, onContactSupport }) => {
  const { isGuest } = useTeamPermissions();

  return (
    <header
      id="top-bar"
      className="sticky top-0 w-full h-14 flex flex-nowrap flex-shrink-0 items-center md:px-4 px-6 z-50 gap-x-2 bg-gray-100"
    >
      <ButtonSquare
        variant="tertiary-gray"
        className="h-8 w-8 rounded-lg hover:bg-base-black/[0.04] hidden md:block"
        onClick={onToggleMenu}
      >
        <Icon glyph={IconMap.Menu05} width={20} />
      </ButtonSquare>
      <SelectTeamDropdown />
      <div className="ml-auto flex flex-row items-center gap-x-4">
        {!isGuest && <WorkspaceSearch />}
        <ProfileDropdown onContactSupport={onContactSupport} />
      </div>
    </header>
  );
};

export const HeaderMobileSidebar: FC<Pick<Props, 'onToggleMenu'>> = ({
  onToggleMenu,
}) => {
  return (
    <header className="w-full h-14 hidden md:flex flex-nowrap flex-shrink-0 items-center gap-x-2 bg-gray-100">
      <ButtonSquare
        variant="tertiary-gray"
        className="h-8 w-8 rounded-lg hover:bg-base-black/[0.04]"
        onClick={onToggleMenu}
      >
        <Icon glyph={IconMap.XClose} width={20} />
      </ButtonSquare>
    </header>
  );
};
